//@ vendors
const { Promise } = require('es6-promise');
const moment = require('moment');
const get = require('lodash/object/get');
//@ helpers
const actionTypes = require('constants/actionTypes');
const transferCodes = require('constants/transferCodes');
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');

// @ constants
const { EURO_TEXT, DATE_FORMAT_API } = require('constants/index');

const reset = () => ({ type: actionTypes.PASS_RESET });

const showError = (error, dispatch, history) => {
    const errorKey = get(error, ['body', 'error'], '');
    dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
};

const setVisibleStep = data => ({
    type: actionTypes.PASS_SET_VISIBLE_STEP,
    payload: {
        data
    }
});

const setFromAccount = (accountId = '', amount = '', isInitialAccount = false, isPredefinedToAccount = false) => ({
    type: actionTypes.PASS_FROM_ACCOUNT,
    payload: {
        accountId,
        amount,
        isInitialAccount,
        isPredefinedToAccount,
    }
});

const setToAccount = (accountId = '', currency = '') => ({
    type: actionTypes.PASS_TO_ACCOUNT,
    payload: {
        accountId,
        currency
    }
});

const setNewAccountNotFoundError = (isError) => ({
    type: actionTypes.PASS_SET_NEW_ACCOUNT_NOT_FOUND_ERROR,
    payload: { isError }
});

const setPredefinedToAccount = (isPredefined) => ({
    type: actionTypes.PASS_PREDEFINED_TO_ACCOUNT,
    payload: { isPredefined }
});

const setAmount = (amount, maxTransferLimit = null)  => ({
    type: actionTypes.PASS_AMOUNT,
    payload: { amount, maxTransferLimit }
});

const setConcept = concept => ({
    type: actionTypes.PASS_CONCEPT,
    payload: { concept }
});

const setWillLeave = () => ({ type: actionTypes.PASS_WILL_LEAVE });

const setWillCancel = value => ({
    type: actionTypes.PASS_WILL_CANCEL,
    payload: { value }
});

const passRequest = () => ({ type: actionTypes.PASS_REQUEST_TRANSFER_REQUEST });

const passSuccess = data => ({
    type: actionTypes.PASS_REQUEST_TRANSFER_SUCCESS,
    payload: { data }
});

const passFailure = error => ({
    type: actionTypes.PASS_REQUEST_TRANSFER_FAILURE,
    payload: { error }
});

const validateUIStep = data => ({
    type: actionTypes.PASS_VALIDATE_UI_STEP,
    payload: { data }
});

const validationRequest = () => ({
    type: actionTypes.PASS_VALIDATE_STEP_REQUEST
});

const validationSuccess = (step, data) => ({
    type: actionTypes.PASS_VALIDATE_STEP_SUCCESS,
    payload: {
        data,
        step
    }
});

const validationFailure = error => ({
    type: actionTypes.PASS_VALIDATE_STEP_FAILURE,
    payload: {
        error
    }
});

const validateWithAPI = (step, history) => (dispatch, getState) => {
    const immPass = getState().pass;
    const immPassStep1 = immPass.getIn(['steps', 0]);
    const valid = immPassStep1.get('valid');
    const accountsSource = immPass.get('isFutureTransfer') ? 'futureAccountsById' : 'byId';

    const fromAccountId = immPassStep1.get('fromAccount');
    const immFromAccount = getState().accounts.getIn(['byId', fromAccountId]);

    const toAccountId = immPassStep1.get('toAccount');
    const immToAccount = getState().accounts.getIn([accountsSource, toAccountId]);

    if (valid) {
        const requestData = {
            header: {
                version: 2
            },
            query: {
                autonomo: 'N',
                concepto: immPassStep1.get('concept'),
                contratoOrdenantePartenon: {
                    numerodecontrato: immFromAccount.get('newContractNumber'),
                    producto: immFromAccount.get('newProduct')
                },
                cuentaBeneficiario: immToAccount.get('ibanComplex').toJS(),
                fechaEmision: moment().format(DATE_FORMAT_API), // (andres): PAss money is always in the same day
                importe: {
                    divisa: EURO_TEXT,
                    importe: immPassStep1.get('amount')
                },
                nombreTitularBeneficiario: immToAccount.get('accountHolder')
            }
        };

        dispatch(validationRequest());
        return APIPost({dispatch, endpoint: 'passMoneyValidation', params: requestData})
            .then((response) => dispatch(validationSuccess(step, response)))
            .catch(response => {
                if (response.error) {
                    dispatch(validationFailure(response.error));
                }
                if (immPass.get('isFutureTransfer')) {
                    showError(response, dispatch, history);
                }
            });
    }
};

const validateStep = (step, history, flag=true) => dispatch => {
    if(flag && step === 1)
    {
        dispatch(validateUIStep(step));
        dispatch(validateWithAPI(step, history));
    }
    else {
        dispatch(validateUIStep(step));
    }
};

const setFutureTransfer = () => ({
    type: actionTypes.PASS_SET_FUTURE_TRANSFER
});

const resetAccountRedirectionState = () => ({
    type: actionTypes.RESET_REDIRECTION_ACCOUNT_STATE
});

const postTransfer = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immPass = getState().pass;
        const immPassStep1 = immPass.getIn(['steps', 0]);
        const accountsSource = immPass.get('isFutureTransfer') ? 'futureAccountsById' : 'byId';

        const fromAccountId = immPassStep1.get('fromAccount');
        const immFromAccount = getState().accounts.getIn(['byId', fromAccountId]);

        const toAccountId = immPassStep1.get('toAccount');
        const immToAccount = getState().accounts.getIn([accountsSource, toAccountId]);

        const requestData = {
            header: {
                version: immPass.get('isFutureTransfer') ? 3 : 2
            },
            query: {
                concepto: immPassStep1.get('concept'),
                contratoOrdenantePartenon: {
                    numerodecontrato: immFromAccount.get('newContractNumber'),
                    producto: immFromAccount.get('newProduct')
                },
                cuentaBeneficiario: immToAccount.get('ibanComplex').toJS(),
                divisaCtaOrd: EURO_TEXT,
                importe: {
                    divisa: EURO_TEXT,
                    importe: immPassStep1.get('amount')
                },
                indDivisa: '01',
                nombreTitularBeneficiario: immToAccount.get('accountHolder'),
                tipoCtoExt: 1,
                tipoTransferencia: {
                    indtipoperacion: transferCodes.TRANSFER_PASS.OPERATION_ID,
                    naturalezapagomispag: {
                        codalfanum: transferCodes.TRANSFER_PASS.ALPHANUM
                    }
                },
                dataToken
            }
        };

        if (immPass.get('isFutureTransfer')) {
            requestData.query.subTipo = '804';
            requestData.query.numeroContratoDerivados = immToAccount.get('newContractNumber');
            requestData.query.productoDerivados = immToAccount.get('newProduct');
        }

        dispatch(passRequest());
        return APIPost({dispatch, endpoint: 'passMoneyConfirmation', params: requestData})
            .then((response) => dispatch(passSuccess(response)))
            .catch(response => {
                if (response.error) {
                    dispatch(passFailure(response.error));
                }
                if (immPass.get('isFutureTransfer')) {
                    showError(response, dispatch, history);
                }
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    reset,
    resetAccountRedirectionState,
    setVisibleStep,
    setFromAccount,
    setNewAccountNotFoundError,
    setPredefinedToAccount,
    setToAccount,
    setAmount,
    setConcept,
    setFutureTransfer,
    setWillLeave,
    setWillCancel,
    postTransfer,
    validateStep
};
